// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3eSBx","unreadBadge":"styles_unreadBadge__3GdP-","modalContent":"styles_modalContent__1rkIG","modal":"styles_modal__1bogk"};